// LabeledInput.tsx
import React from "react";

type LabeledInputProps = {
	label: string;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	isVisible?: boolean;
	type: string;
};

const LabeledInput = ({
	label,
	value,
	onChange,
	isVisible,
	type,
}: LabeledInputProps) => {
	return (
		<div
			className={`flex flex-col items-start gap-1 w-full ${
				isVisible ? "" : "hidden"
			}`}
			key={`labeledInput-${label}`}
		>
			<span className="text-xs text-highlight2">{label}</span>
			<input
				value={value}
				onChange={onChange}
				type={type}
				className="w-full px-2 py-1 bg-transparent border border-elevation1 rounded-md text-highlight2 hover:bg-black/70 hover:text-white focus:outline-none focus:bg-black/70 focus:border-accent1 focus:text-white"
			/>
		</div>
	);
};

export default LabeledInput;
